import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { initialQuery, TableParams } from '@supplement-bacon/sb-table-filters'
import { Card, Empty, Flex, Spin } from 'antd'
import { FC, useEffect } from 'react'
import { MembershipProfile as MembershipProfileModel } from '../../../models/membership/MembershipProfile'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { getEvents, selectEvents } from '../../../store/membership/EventReducer'
import { selectMembershipProfileById } from '../../../store/membership/MembershipProfileReducer'
import Event from '../../event/Event'

type Props = SBModelComponent<MembershipProfileModel> & {}

const EventParticipations: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectMembershipProfileById(id!))

  const events = useAppSelector(selectEvents())
  const dispatch = useAppDispatch()

  const { isLoading } = useAppSelector((state) => state.event)

  useEffect(() => {
    if (!item) return
    const query: TableParams = {
      ...initialQuery,
      pagination: { ...initialQuery.pagination, pageSize: 3000 },
      filters: {
        ...initialQuery.filters,
        membershipProfiles: [item.id],
      },
    }
    dispatch(getEvents(query))
  }, [item])

  if (!item) {
    return <></>
  }

  if (isLoading) {
    return (
      <Card>
        <Spin />
      </Card>
    )
  }
  return (
    <Card>
      {events.length == 0 && (
        <Flex
          vertical
          gap={24}
          align="center"
          justify="center"
          style={{ minHeight: 200 }}
        >
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={'Event participations not found'}
          />
        </Flex>
      )}
      <Flex vertical gap={24} align="flex-start">
        {events.map((event) => (
          <Event.CardWithMemberParticipation model={event} />
        ))}
      </Flex>
    </Card>
  )
}

type EventParticipationsType = {
  EventParticipations: typeof EventParticipations
}

export { EventParticipations, type EventParticipationsType }
